package pl.michal_cyran.brand_hub.subpages.tutoring.composables

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import org.jetbrains.compose.web.css.AnimationTimingFunction.Companion.EaseIn
import org.jetbrains.compose.web.css.AnimationTimingFunction.Companion.EaseOut
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.css.s
import org.jetbrains.compose.web.dom.H3
import org.jetbrains.compose.web.dom.H5
import org.jetbrains.compose.web.dom.Text
import pl.michal_cyran.brand_hub.components.widgets.VisibilityAware
import pl.michal_cyran.brand_hub.toSitePalette

@Composable
fun OfferHeading(
    title: String,
    icon: @Composable (size: IconSize) -> Unit,
    modifier: Modifier = Modifier
) {
    val cm = ColorMode.current.toSitePalette()

    VisibilityAware(
        modifier = Modifier.fillMaxWidth()
    ) { isVisible ->
        Column(
            modifier = modifier
                .padding(leftRight = 16.px, topBottom = 8.px)
                .fillMaxWidth(),
            horizontalAlignment = Alignment.CenterHorizontally,
            verticalArrangement = Arrangement.spacedBy(10.px)
        ) {
            Box(
                modifier = Modifier
                    .size(100.px)
                    .color(cm.primary)
                    .borderRadius(8.px)
                    .opacity(if (isVisible) 1 else 0)
                    .transform {
                        scale(if (isVisible) 1.0 else 0.4)
                        rotate(if (isVisible) 0.deg else (-15).deg)
                    }
                    .transition(
                        Transition.of("opacity", 0.4.s, EaseOut, 0.ms),
                        Transition.of("transform", 0.5.s, EaseIn, 0.ms)
                    ),
                contentAlignment = Alignment.Center,
            ) {
                icon(IconSize.X5)
            }

            H3(
                Modifier
                    .color(cm.primaryMuted)
                    .opacity(if (isVisible) 1 else 0)
                    .transform { translateY(if (isVisible) 0.px else 12.px) }
                    .transition(
                        Transition.of("opacity", 0.4.s, EaseOut, 150.ms),
                        Transition.of("transform", 0.4.s, EaseOut, 150.ms)
                    )
                    .toAttrs()
            ) {
                Text(title)
            }
        }
    }
}